import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"

import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"

const styles = (theme) => ({
    paperrtl: {
        marginTop: theme.spacing(0),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    paper: {
        display: "flex",
        flexWrap: "wrap",
        "& > *": {
            margin: theme.spacing(1),
            width: theme.spacing(20),
        },
    },
    root: {
        width: "100%",
        margin: "15px",
        padding: "8px",
        direction: "rtl",
    },
    container: {
        maxHeight: 400,
    },
    large: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    small: {
        width: theme.spacing(6),
        height: theme.spacing(6),
    },
})

class ChangeAccidentJobClass extends Component {
    cookies = new Cookies()
    temp333
    constructor(props) {
        super(props)
        this.state = {
            redirect: false,
            errstr: "",
            errstatus: false,
            okstatus: false,
            requestinfos: [],
            agentInfofilter: [],
            rowsPerPage: 10,
            page: 0,
            accident_job_class_id: "",
            accident_job_class_name: "",
            accident_job_class_rate: "",

            orderBy: "accident_job_class_id",
            order: "desc",
            snackstr: "",
            showSnack: false,
            snackMode: "success",
            newAccidentJobClass: true,
        }
    }

    handleChangeAccidentJobClassName = (event) => {
        this.setState({ accident_job_class_name: event.target.value })
    }


    handleChangeAccidentJobClassDesc = (event) => {

        this.setState({ accident_job_class_rate: event })

    }

    handleChangeAccidentJobClassId = (event) => {
        this.setState({ accident_job_class_id: event })
    }

    handleClickcloseTasckBar = (event) => {
        this.setState({ showSnack: false })
    }

    handleSelectRows = (row2) => {
        this.setState(
            {
                accident_job_class_id: row2.accident_job_class_id,
                accident_job_class_name: row2.accident_job_class_name,
                accident_job_class_rate: row2.accident_job_class_rate,
                newAccidentJobClass: false,
            },
            () => {}
        )
    }

    newAccidentJobClass = (event) => {
        this.setState({
            accident_job_class_id: "",
            accident_job_class_name: "",
            accident_job_class_rate: "",
            newAccidentJobClass: true,
        })
    }
    componentDidMount() {
        if (this.cookies.get("employee_token_str")) {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    if (arr.result === "ok") {
                        self.getAccidentJobClass()
                    } else if (arr.result === "error") {
                        self.setState({ redirect: true })
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "checkemployeelogin")

            xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        } else {
            this.setState({ redirect: true })
        }
    }

    getAccidentJobClass() {
        this.props.props.props.dispatch({
            type: "WAITSHOW",
        })
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                console.log(arr)
                if (arr.result === "ok") {
                    self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {})
                } else if (arr.result === "error") {
                }
                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                })
            }
        }
        var fd = new FormData()
        fd.append("command", "get_accident_job_class")

        xhttp.open("POST", `${constants.BASE_URL}/Accident`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }

    saveNewAccidentJobClass = () => {
        const { accident_job_class_id, accident_job_class_name, accident_job_class_rate } = this.state
        if (accident_job_class_id != "" && accident_job_class_name != "") {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    console.log(arr)
                    if (arr.result === "ok") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        //self.setState({ redirect: true })
                        self.getAccidentJobClass()
                    } else if (arr.result === "error") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "add_accident_job_class")
            fd.append("accident_job_class_id", accident_job_class_id)
            fd.append("accident_job_class_name", accident_job_class_name)
            fd.append("accident_job_class_rate", accident_job_class_rate)

            xhttp.open("POST", `${constants.BASE_URL}/Accident`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        } else {
            this.setState({ snackstr: "لطفا مشخصات طبقه شغلی  را وارد نمایید", showSnack: true, snackMode: "error" })
        }
    }

    deleteAccidentJobClass = () => {
        const { accident_job_class_id } = this.state

        this.props.props.props.dispatch({
            type: "WAITSHOW",
        })

        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                console.log(arr)
                if (arr.result === "ok") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                    self.newAccidentJobClass()
                    self.getAccidentJobClass()
                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                })
            }
        }
        var fd = new FormData()
        fd.append("command", "delete_accident_job_class")
        fd.append("accident_job_class_id", accident_job_class_id)

        xhttp.open("POST", `${constants.BASE_URL}/Accident`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }

    changeAccidentJobClass = () => {
        const { accident_job_class_id, accident_job_class_name, accident_job_class_rate } = this.state
        if (accident_job_class_id != "" && accident_job_class_name != "") {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    console.log(arr)
                    if (arr.result === "ok") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        //self.setState({ redirect: true })
                        self.getAccidentJobClass()
                    } else if (arr.result === "error") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "modify_accident_job_class")
            fd.append("accident_job_class_id", accident_job_class_id)
            fd.append("accident_job_class_name", accident_job_class_name)
            fd.append("accident_job_class_rate", accident_job_class_rate)

            xhttp.open("POST", `${constants.BASE_URL}/Accident`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        } else {
            this.setState({ snackstr: "لطفا مشخصات طبقه شغلی  را وارد نمایید", showSnack: true, snackMode: "error" })
        }
    }

    createSortHandler = (field) => {
        if (this.state.orderBy === field) {
            if (this.state.order === "asc") {
                this.setState({ order: "desc" })
            } else {
                this.setState({ order: "asc" })
            }
        } else {
            this.setState({ orderBy: field, order: "asc" })
        }
        var arraytemp = [],
            i,
            j,
            temp,
            a,
            b
        arraytemp = this.state.agentInfofilter
        for (i = 0; i < arraytemp.length; i++) {
            for (j = 0; j < arraytemp.length - 1; j++) {
                a = arraytemp[j]
                b = arraytemp[j + 1]
                if (a[field] < b[field] && this.state.order === "asc") {
                    temp = arraytemp[j]
                    arraytemp[j] = arraytemp[j + 1]
                    arraytemp[j + 1] = temp
                } else if (a[field] > b[field] && this.state.order === "desc") {
                    temp = arraytemp[j]
                    arraytemp[j] = arraytemp[j + 1]
                    arraytemp[j + 1] = temp
                }
            }
        }
    }



    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
    }

    handleChangePage = (event, number) => {
        this.setState({ page: parseInt(number, 0) })
    }

    render() {
        const { classes } = this.props
        const {
            agentPermision,
            snackMode,
            snackstr,
            showSnack,
            newAccidentJobClass,
            accident_job_class_id,
            accident_job_class_name,
            accident_job_class_rate,
            order,
            orderBy,
            okstatus,
            errstr,
            redirect,
            agentInfofilter,
            rowsPerPage,
            page,
        } = this.state
        if (redirect) {
            return <Redirect to="/" />
        } else {
            return (
                <div className={classes.paperrtl} dir="ltr">
                    <Snackbar
                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                        onClose={this.handleClickcloseTasckBar}
                        open={showSnack}
                        autoHideDuration={10000}
                    >
                        <Alert severity={snackMode}>{snackstr}</Alert>
                    </Snackbar>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Container component="main" maxWidth="lg">
                                <Paper elevation={4} className={classes.root}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}></Grid>

                                        <Grid item xs={6}>
                                            <Typography align="center" variant="h7">
                                                <FloatingLabelInput
                                                    type="number"
                                                    placeholder="آی دی طبقه شغلی "
                                                    handleInputt={this.handleChangeAccidentJobClassId}
                                                    value={accident_job_class_id}
                                                />
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={6}>
                                            <FloatingLabelInput
                                                placeholder="طبقه شغلی "
                                                handleInputt={this.handleChangeAccidentJobClassName}
                                                value={accident_job_class_name}
                                            />
                                        </Grid>

                                        <Grid item xs={6}>
                                            <FloatingLabelInput
                                                type="percent"
                                                placeholder="مبلغ طبقه شغلی "
                                                handleInputt={this.handleChangeAccidentJobClassDesc}

                                                value={accident_job_class_rate !== null ? accident_job_class_rate : "0"} // مقدار پیش‌فرض ۰
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Divider />
                                        </Grid>

                                        <Grid item xs={12}>
                                            {newAccidentJobClass ? (
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={(e) => {
                                                        this.saveNewAccidentJobClass()
                                                    }}
                                                >
                                                    {"ثبت طبقه شغلی  جدید "}
                                                </Button>
                                            ) : (
                                                <div style={{ width: "100%", textAlign: "right" }}>
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={this.newAccidentJobClass}
                                                    >
                                                        {"طبقه شغلی  جدید"}
                                                    </Button>
                                                    {"          "}
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={(e) => {
                                                            this.changeAccidentJobClass()
                                                        }}
                                                    >
                                                        {"ثبت تغییرات"}
                                                    </Button>
                                                    {"          "}
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={(e) => {
                                                            this.deleteAccidentJobClass()
                                                        }}
                                                    >
                                                        {"حذف"}
                                                    </Button>
                                                </div>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Container>
                        </Grid>
                        <Grid item xs={12}>
                            <Container maxWidth="lg">
                                <Paper className={classes.root}>
                                    <TableContainer dir="rtl">
                                        <Table aria-label="sticky table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell
                                                        key={"accident_job_class_id"}
                                                        align={"center"}
                                                        style={{ minWidth: 20 }}
                                                        sortDirection={orderBy === "accident_job_class_id" ? order : false}
                                                    >
                                                        {"آیدی طبقه شغلی  "}
                                                        <TableSortLabel
                                                            active={orderBy === "accident_job_class_id"}
                                                            direction={
                                                                orderBy === "accident_job_class_id" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("accident_job_class_id")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                    <TableCell
                                                        key={"accident_job_class_name"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"طبقه شغلی  "}
                                                        <TableSortLabel
                                                            active={orderBy === "accident_job_class_name"}
                                                            direction={
                                                                orderBy === "accident_job_class_name" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("accident_job_class_name")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>



                                                    <TableCell
                                                        key={"accident_job_class_rate"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"مبلغ طبقه شغلی  "}
                                                        <TableSortLabel
                                                            active={orderBy === "accident_job_class_rate"}
                                                            direction={
                                                                orderBy === "accident_job_class_rate" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("accident_job_class_rate")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>


                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {agentInfofilter
                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    .map((row) => {
                                                        return (
                                                            <TableRow
                                                                hover
                                                                role="checkbox"
                                                                tabIndex={-1}
                                                                key={row["accident_job_class_id"]}
                                                                value={row}
                                                                onClick={() => {
                                                                    this.handleSelectRows(row)
                                                                }}
                                                            >
                                                                <TableCell
                                                                    key={"accident_job_class_id"}
                                                                    align={"center"}
                                                                >
                                                                    {row["accident_job_class_id"]}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"accident_job_class_name"}
                                                                    align={"center"}
                                                                >
                                                                    {row["accident_job_class_name"]}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"accident_job_class_rate"}
                                                                    align={"center"}
                                                                >
                                                                    {row["accident_job_class_rate"]}
                                                                </TableCell>
                                                            </TableRow>
                                                        )
                                                    })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <TablePagination
                                        rowsPerPageOptions={[10, 25, 100]}
                                        component="div"
                                        count={agentInfofilter.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />
                                </Paper>
                            </Container>
                        </Grid>
                    </Grid>

                    {okstatus ? (
                        <Alert severity="success">
                            <AlertTitle>پیام</AlertTitle>
                            {errstr}
                        </Alert>
                    ) : null}
                </div>
            )
        }
    }
}

export default withStyles(styles)(ChangeAccidentJobClass)
